<template>
  <div>
    <h5 class="text-center info-text">Complete la información del seguimiento de Pre Emergencia</h5>

    <div class="row justify-content-center mt-5">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label"> Fecha de Siembra </label>

          <el-date-picker
            v-model="formData.seedDate"
            v-validate="modelValidations.seedDate"
            align="center"
            :editable="false"
            format="dd-MM-yyyy"
            name="seedDate"
            placeholder="Fecha de Siembra (*)"
            suffix-icon="fas fa-calendar-alt"
            type="date"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>

          <small v-show="seedDate.invalid" class="text-danger">
            {{ getError('seedDate') }}
          </small>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label"> Destino Producción </label>

          <el-select
            v-model="formData.productionDestination"
            v-validate="modelValidations.productionDestination"
            autocomplete="off"
            filterable
            name="productionDestination"
            placeholder="Destino de producción (*)"
          >
            <el-option
              v-for="option in productionDestinationsOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
              :selected="option.value === formData.productionDestination"
            >
            </el-option>
          </el-select>

          <small v-show="productionDestination.invalid" class="text-danger">
            {{ getError('productionDestination') }}
          </small>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label"> Semillas por metro </label>

          <el-input
            v-model="formData.seedsPerMeter"
            v-validate="modelValidations.seedsPerMeter"
            name="seedsPerMeter"
            placeholder="Semillas por metro"
          >
          </el-input>

          <small v-show="seedsPerMeter.invalid" class="text-danger">
            {{ getError('seedsPerMeter') }}
          </small>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label"> Distanciamiento entre Surcos: &nbsp; </label>
          <label v-if="plot.groovesDistance" class="text-lg font-weight-bolder">
            {{ plot.groovesDistance | decimals }} cm.
          </label>
          <span v-else class="text-danger d-block small">
            Debe cargar la distancia entre surcos del lote para poder realizar el calculo de semillas por hectárea
          </span>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label">Semillas por Hectárea: &nbsp;</label>
          <label class="text-lg font-weight-bolder">
            {{ formData.seedsPerMeter | seedsPerHectare(plot.groovesDistance) }}
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="row justify-content-center mb-4">
          <div class="col-sm-12">
            <el-checkbox
              v-model="formData.hasNitrogenFertilization"
              border
              class="form-control"
              label="Fertilización Nitrogenada"
            ></el-checkbox>
          </div>

          <div class="col-sm-12">
            <el-input
              v-if="formData.hasNitrogenFertilization"
              v-model="formData.nitrogenFertilization"
              v-validate="modelValidations.nitrogenFertilization"
              name="nitrogenFertilization"
              placeholder="Kg/Ha"
            >
            </el-input>

            <small v-show="nitrogenFertilization.invalid" class="text-danger">
              {{ getError('nitrogenFertilization') }}
            </small>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12">
        <div class="row justify-content-center mb-4">
          <div class="col-sm-12">
            <el-checkbox
              v-model="formData.hasPhosphateFertilization"
              border
              class="form-control"
              label="Fertilización Fosfatada"
            ></el-checkbox>
          </div>

          <div class="col-sm-12">
            <el-input
              v-if="formData.hasPhosphateFertilization"
              v-model="formData.phosphateFertilization"
              v-validate="modelValidations.phosphateFertilization"
              name="phosphateFertilization"
              placeholder="Kg/Ha"
            >
            </el-input>

            <small v-show="phosphateFertilization.invalid" class="text-danger">
              {{ getError('phosphateFertilization') }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="row justify-content-center">
          <div class="col-sm-12">
            <el-checkbox
              v-model="formData.hasPestControl"
              border
              class="form-control"
              label="Control de Plagas"
            ></el-checkbox>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-sm-12 mb-4">
            <el-input
              v-if="formData.hasPestControl"
              v-model="formData.pestControl"
              v-validate="modelValidations.pestControl"
              name="pestControl"
              placeholder="Producto y dosis"
            >
            </el-input>

            <small v-show="pestControl.invalid" class="text-danger">
              {{ getError('pestControl') }}
            </small>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12">
        <div class="row justify-content-center">
          <div class="col-sm-12">
            <el-checkbox v-model="formData.hasWeedControl" border class="form-control" label="Control de Malezas">
            </el-checkbox>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-sm-12 mb-4">
            <el-input
              v-if="formData.hasWeedControl"
              v-model="formData.weedControl"
              v-validate="modelValidations.weedControl"
              name="weedControl"
              placeholder="Producto y dosis"
            >
            </el-input>

            <small v-show="weedControl.invalid" class="text-danger">
              {{ getError('weedControl') }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <button class="btn btn-success btn-fill btn-wd btn-next float-right" @click="save">Guardar</button>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Select, Option, DatePicker, Checkbox } from 'element-ui';

export default {
  components: {
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },

  props: {
    plot: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        hasNitrogenFertilization: this.plot.preEmergence
          ? Boolean(this.plot.preEmergence.nitrogenFertilization)
          : false,

        hasPhosphateFertilization: this.plot.preEmergence
          ? Boolean(this.plot.preEmergence.phosphateFertilization)
          : false,

        hasWeedControl: this.plot.preEmergence ? Boolean(this.plot.preEmergence.weedControl) : false,
        hasPestControl: this.plot.preEmergence ? Boolean(this.plot.preEmergence.pestControl) : false,
        nitrogenFertilization: this.plot.preEmergence ? this.plot.preEmergence.nitrogenFertilization : null,
        phosphateFertilization: this.plot.preEmergence ? this.plot.preEmergence.phosphateFertilization : null,
        weedControl: this.plot.preEmergence ? this.plot.preEmergence.weedControl : null,
        pestControl: this.plot.preEmergence ? this.plot.preEmergence.pestControl : null,
        seedDate: this.plot.preEmergence ? this.plot.preEmergence.seedDate : null,
        plotId: this.plot.id,
        productionDestination:
          this.plot.preEmergence && this.plot.preEmergence.productionDestination
            ? this.plot.preEmergence.productionDestination.id
            : null,

        seedsPerMeter: this.plot.preEmergence ? this.plot.preEmergence.seedsPerMeter : null,
      },

      modelValidations: {
        nitrogenFertilization: {
          required: true,
          min: 0,
          numeric: true,
        },

        phosphateFertilization: {
          required: true,
          min: 0,
          numeric: true,
        },

        weedControl: {
          required: true,
        },

        pestControl: {
          required: true,
        },

        seedDate: {
          required: true,
        },

        productionDestination: {},
        seedsPerMeter: {
          min: 0,
          decimal: 2,
        },
      },

      productionDestinations: [],
    };
  },

  computed: {
    ...mapFields([
      'productionDestination',
      'seedsPerMeter',
      'seedsPerHectare',
      'seedDate',
      'phosphateFertilization',
      'nitrogenFertilization',
      'weedControl',
      'pestControl',
    ]),

    productionDestinationsOptions() {
      return this.$selectOptions(this.productionDestinations);
    },
  },

  mounted() {
    this.fetchProductionDestinations();
  },

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    async validate() {
      try {
        return await this.$validator.validateAll();
      } catch (e) {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      } finally {
      }
    },

    save() {
      this.validate().then((res) => {
        if (res) {
          this.store();
        }
      });
    },

    async store() {
      this.formData.plotId = this.plot.id;
      const response = (await this.plot.preEmergence) ? this.update() : this.create();

      response.then((res) => res.data.data).then((data) => this.$emit('saved', data));
    },

    create() {
      return this.$services.resource('pre_emergences').create(this.formData);
    },

    update() {
      return this.$services.resource('pre_emergences').update(this.plot.preEmergence.id, this.formData);
    },

    fetchProductionDestinations() {
      return this.$services
        .resource('production_destinations')
        .get()
        .then((res) => res.data.data)
        .then((data) => (this.productionDestinations = data.productionDestinations));
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
